import axios from 'axios';

export const postDeploy = async() => {
  return await axios.post('https://api.netlify.com/build_hooks/5e7d9b0a9da3882d0d69400e')
}